var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraf4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "463px",
    height: "595px",
    viewBox: "0 0 463 595",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graf-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.759483,260.944474 C126.980325,260.944474 125.423585,260.277299 124.089217,258.942931 C122.754849,257.608563 122.087675,256.051823 122.087675,254.272666 C122.087675,251.15914 122.19887,248.82403 122.421265,247.267267 C123.978028,238.149084 127.480692,229.920603 132.929363,222.581578 C138.378033,215.242552 145.772546,207.014071 155.113124,197.895888 C162.00736,191.224047 167.233558,185.608664 170.791873,181.049573 C174.350188,176.490481 176.240515,171.987056 176.46291,167.539162 C177.130094,161.089715 175.072974,155.863518 170.291487,151.860413 C165.510001,147.857308 159.561032,145.855786 152.444401,145.855786 C135.987192,145.855786 125.868385,153.750679 122.087675,169.540704 C120.975701,172.209441 119.641353,174.210963 118.08459,175.545331 C116.527827,176.879699 114.303913,177.546874 111.412782,177.546874 L68.0460299,177.546874 C65.8220827,177.546874 63.9873539,176.712906 62.5417883,175.044946 C61.0962226,173.376985 60.3734507,171.208669 60.3734507,168.539933 C60.8182401,156.530618 64.7100892,144.966267 72.0491147,133.846531 C79.3881401,122.726796 90.2853176,113.664347 104.740974,106.658914 C119.19663,99.6534802 136.431962,96.150816 156.447486,96.150816 C176.907799,96.150816 193.531555,99.3198931 206.319251,105.658142 C219.106947,111.996392 228.280591,119.724492 233.840459,128.842675 C239.400326,137.960858 242.180219,147.1901 242.180219,156.530678 C242.180219,167.872809 239.622718,177.769225 234.507639,186.220224 C229.392561,194.671223 222.053646,204.122857 212.490673,214.575408 C206.486016,221.247249 201.926993,226.584642 198.813467,230.587747 C195.699941,234.590852 193.14244,238.927484 191.140887,243.597773 C190.251309,245.599325 189.472939,248.379217 188.805755,251.937533 C187.026597,255.273453 185.414259,257.608563 183.968694,258.942931 C182.523128,260.277299 180.577204,260.944474 178.130862,260.944474 L128.759483,260.944474 Z M129.760254,333 C127.313912,333 125.256792,332.22163 123.588831,330.664867 C121.920871,329.108104 121.086903,327.106582 121.086903,324.66024 L121.086903,284.962982 C121.086903,282.516641 121.920871,280.45952 123.588831,278.79156 C125.256792,277.1236 127.313912,276.289632 129.760254,276.289632 L174.461367,276.289632 C176.907709,276.289632 178.96483,277.1236 180.63279,278.79156 C182.30075,280.45952 183.134718,282.516641 183.134718,284.962982 L183.134718,324.66024 C183.134718,327.106582 182.30075,329.108104 180.63279,330.664867 C178.96483,332.22163 176.907709,333 174.461367,333 L129.760254,333 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.4%",
    y: "-19.2%",
    width: "158.9%",
    height: "145.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.917647059   0 0 0 0 0.917647059   0 0 0 0 0.988235294  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-63.3%",
    y: "-3.0%",
    width: "226.7%",
    height: "105.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "1.1%",
    width: "240.0%",
    height: "96.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "1.1%",
    width: "240.0%",
    height: "96.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "-1.9%",
    width: "240.0%",
    height: "104.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-45.0%",
    y: "-2.1%",
    width: "240.0%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.770642,562.194366 C146.527823,562.194366 145.440372,561.723948 144.508257,560.783099 C143.576142,559.842249 143.110092,558.744607 143.110092,557.490141 C143.110092,555.294825 143.187767,553.648362 143.343119,552.550704 C144.430586,546.121564 146.877351,540.319744 150.683486,535.14507 C154.489621,529.970397 159.655013,524.168577 166.179817,517.739437 C170.995743,513.035188 174.646471,509.075838 177.13211,505.861268 C179.617749,502.646698 180.938226,499.471377 181.093578,496.335211 C181.559635,491.787771 180.122647,488.102831 176.782569,485.280282 C173.442491,482.457732 169.286875,481.046479 164.315596,481.046479 C152.819514,481.046479 145.751084,486.61309 143.110092,497.746479 C142.333329,499.628178 141.401229,501.039432 140.313761,501.980282 C139.226294,502.921131 137.672793,503.391549 135.653211,503.391549 L105.359633,503.391549 C103.806108,503.391549 102.52447,502.803527 101.514679,501.627465 C100.504888,500.451403 100,498.922545 100,497.040845 C100.310705,488.573197 103.029332,480.419288 108.155963,472.578873 C113.282594,464.738458 120.894751,458.348616 130.992661,453.409155 C141.09057,448.469694 153.130205,446 167.111927,446 C181.404353,446 193.016775,448.234485 201.949541,452.703521 C210.882308,457.172558 217.2905,462.621564 221.174312,469.050704 C225.058123,475.479844 227,481.987291 227,488.573239 C227,496.570463 225.213474,503.548327 221.640367,509.507042 C218.06726,515.465757 212.940706,522.13001 206.26055,529.5 C202.066034,534.204249 198.881356,537.967592 196.706422,540.790141 C194.531488,543.61269 192.744961,546.670406 191.346789,549.96338 C190.725379,551.374655 190.181654,553.334729 189.715596,555.843662 C188.472777,558.195786 187.346488,559.842249 186.336697,560.783099 C185.326906,561.723948 183.967593,562.194366 182.258716,562.194366 L147.770642,562.194366 Z M148.469725,613 C146.760848,613 145.323859,612.451179 144.158716,611.353521 C142.993572,610.255863 142.411009,608.84461 142.411009,607.119718 L142.411009,579.129577 C142.411009,577.404686 142.993572,575.954231 144.158716,574.778169 C145.323859,573.602107 146.760848,573.014085 148.469725,573.014085 L179.695413,573.014085 C181.40429,573.014085 182.841279,573.602107 184.006422,574.778169 C185.171565,575.954231 185.754128,577.404686 185.754128,579.129577 L185.754128,607.119718 C185.754128,608.84461 185.171565,610.255863 184.006422,611.353521 C182.841279,612.451179 181.40429,613 179.695413,613 L148.469725,613 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-30.3%",
    y: "-20.1%",
    width: "160.6%",
    height: "146.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.917647059   0 0 0 0 0.917647059   0 0 0 0 0.988235294  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "-1.6%",
    width: "242.5%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "-1.5%",
    width: "267.5%",
    height: "103.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-95.0%",
    y: "-6.6%",
    width: "240.0%",
    height: "112.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Statso",
    transform: "translate(-1289.000000, -8249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graf-4",
    transform: "translate(1246.513917, 8203.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.645044,298.816423 C228.215015,286.938808 199.833333,289.333333 188.5,306 C171.5,331 132.5,358.170715 163.5,379.584084 C184.166667,393.859663 225.577143,397.116446 287.73143,389.354433 C293.382262,389.003381 297.181844,388.775497 299.130177,388.670779 C334.72221,386.757801 369.345485,386.985686 403,389.354433 C458.855322,393.285767 514.052309,386 503.52901,355.5 C496.513477,335.166667 467.832501,318.666667 417.486083,306 L273.645044,298.816423 Z",
    id: "Path-72",
    fill: "#EAEAFC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#F7D0BF",
    transform: "translate(273.645044, 161.762133) rotate(-8.000000) translate(-273.645044, -161.762133) ",
    points: "322.131061 141.092027 269.466539 166.96671 212.263264 166.96671 222.781385 179.865583 276.095705 182.43224 335.026824 161.762133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65",
    fill: "#F7D0BF",
    points: "220.099384 327 218.998459 351.069395 203 359.009718 209.204931 368 232.922958 366.241473 244 347.5 240.563174 328.044787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.410216,244.631492 C262.831029,227.981375 233.104151,224.632598 224.229582,234.585163 C215.355014,244.537727 212.880353,276.202704 216.8056,329.580094 L242.475564,330 C247.646581,293.64689 251.304556,274.219103 253.449487,271.716639 C255.594418,269.214174 272.963184,278.256584 305.555784,298.843866 C309.31596,303.01655 311.934104,299.877816 313.410216,289.427667 C314.468546,281.935215 313.869469,272.020378 313.410216,259.442674 C313.289354,256.132583 313.289354,251.195523 313.410216,244.631492 Z",
    id: "Path-32",
    fill: "#34395D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.802177,122.132494 C324.665541,121.070701 312.556349,126.39074 307.474601,138.09261 C302.392853,149.79448 300.848919,162.448362 302.8428,176.054255 L307.474601,199.546081 L312.976046,289.561129 L389.071675,306 L394.075173,299.772577 L402,299.772577 C393.102497,284.846908 386.185032,266.754275 381.247604,245.494677 C376.310177,224.23508 371.519534,191.914886 366.875675,148.534097 L343.802177,122.132494 Z",
    id: "Path-35",
    fill: "#F7465F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66",
    fill: "#F7D0BF",
    points: "361 346.240414 361 365.725787 403 369 366.14288 342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.318468,299.207849 C369.187534,299.636508 352.894885,297.802925 345.440519,293.707102 C337.986154,289.611278 325.761911,288.188401 308.767793,289.438468 L236.518176,335.632624 C230.043853,340.351237 227.679332,346.066314 229.424613,352.777853 C231.169895,359.489393 232.52025,363.731095 233.47568,365.50296 C228.842853,365.50296 225.436198,365.50296 223.255715,365.50296 C219.98499,365.50296 214.373239,365.50296 210.880998,365.50296 C208.552837,365.50296 206.386898,363.57119 204.383181,359.70765 C189.513213,361.526645 180.851876,363.458415 178.399169,365.50296 C175.946462,367.547505 174.146739,370.046519 173,373 L361.804211,371.043089 L361.804211,348.672492 C361.767291,346.59316 362.883265,345.553494 365.15213,345.553494 C367.420996,345.553494 380.530745,354.702329 404.481376,373 L424,373 L370.097654,331 L356.497607,335.632624 C371.938611,327.371119 381.305606,321.44564 384.598593,317.856189 C387.89158,314.266738 391.131539,308.050625 394.318468,299.207849 Z",
    id: "Path-33",
    fill: "#34395D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "?",
    fillRule: "nonzero",
    transform: "translate(151.276835, 214.575408) rotate(16.000000) translate(-151.276835, -214.575408) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.599147,165 L282.976365,202.50407 L213.332772,202.50407 L200.610246,190.962202 C200.16848,190.561433 199.48547,190.594667 199.0847,191.036432 C198.904441,191.235131 198.804588,191.493809 198.804588,191.76209 L198.804588,196.553681 C192.923258,193.212864 188.430906,192.028304 185.327531,193 C182.224156,193.971696 182.224156,197.744125 185.327531,204.317286 L208.486622,211.747204 C260.496665,217.915735 287.672661,221 290.014612,221 C292.356562,221 311.685025,210.44137 348,189.324111 L325.599147,165 Z",
    id: "Path-36",
    fill: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,405.372026 L209.5,471.38425",
    id: "Path-70",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5,390.354433 L151.5,420.38962",
    id: "Path-70",
    stroke: "url(#linearGradient-5)",
    strokeWidth: 4.8,
    filter: "url(#filter-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,430.354433 L188.5,460.38962",
    id: "Path-70",
    stroke: "url(#linearGradient-5)",
    strokeWidth: 4.8,
    filter: "url(#filter-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,517.926933 L211.5,595.37322",
    id: "Path-70",
    stroke: "url(#linearGradient-8)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,412.077938 L132.5,474.369304",
    id: "Path-70",
    stroke: "url(#linearGradient-10)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "?",
    fillRule: "nonzero",
    transform: "translate(163.500000, 529.500000) rotate(-20.000000) translate(-163.500000, -529.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.308853,56.2857669 L295.486083,84.0283092 L299.942171,85.5354372 C302.302029,98.4174133 305.579349,104.858401 309.774134,104.858401 C310.98465,104.858401 315.758981,103.737214 316.552949,105.815092 C317.857853,109.230134 317.292033,121.387025 314.855488,142.285767 L344.486083,130.934899 L341.344444,74.3429922 L304.308853,56.2857669 Z",
    id: "Path-38",
    fill: "#F7D0BF",
    transform: "translate(319.986083, 99.285767) rotate(-11.000000) translate(-319.986083, -99.285767) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.730433,59.1435407 C301.779231,69.4244621 299.968671,74.5649229 299.298752,74.5649229 C298.293873,74.5649229 293.590365,68.5149756 294.637041,63.8292581 C295.334825,60.7054465 298.171687,57.5821012 303.147626,54.459222 C312.09486,46.5261393 322.176416,43.2326161 333.392293,44.5786525 C350.216108,46.5977072 370.025215,52.0001924 368.706443,83.65606 C367.387672,115.311928 382.258565,132.459278 379.024662,149.022165 C375.790759,165.585052 370.505935,174.659628 368.192818,176.128985 C365.879702,177.598342 351.145849,168.562036 349.634669,156.476382 C348.123489,144.390728 351.79379,143.209507 348.602404,139.324558 C345.411018,135.439609 337.498882,127.995612 337.498882,123.416897 C337.498882,118.838182 340.790367,112.415952 337.498882,109.717818 C334.207398,107.019684 324.413693,104.24462 323.481845,94.1213722 C322.549998,83.9981245 320.859751,64.9461374 318.661799,63.8292581 C317.196497,63.084672 312.552709,61.5227662 304.730433,59.1435407 Z",
    id: "Path-62",
    fill: "#34395D",
    transform: "translate(336.986083, 110.285767) rotate(-11.000000) translate(-336.986083, -110.285767) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.5504249,418.017122 L91.5,504.379334",
    id: "Path-70",
    stroke: "url(#linearGradient-14)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.050425,368.021778 L111.5,461.376493",
    id: "Path-70",
    stroke: "url(#linearGradient-16)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,397.354433 L102.5,427.38962",
    id: "Path-70",
    stroke: "url(#linearGradient-5)",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    filter: "url(#filter-18)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraf4);
export default __webpack_public_path__ + "static/media/graf-4.d6e73bf9427e459a30d202779b574a60.svg";
export { ForwardRef as ReactComponent };